import CartApi from '@apis/cart/CartApi';
import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useActivity } from '@stackflow/react';
import useCalculatedCart from '@store/cart/hooks/useCalculatedCart';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

interface Props {
    shopId: string;
    cartId: string;
}

function useCartQuantity({ shopId, cartId }:Props) {
  const toast = useToast();
  const { orderLines } = useCalculatedCart();
  const { isActive } = useActivity();
  const queryClient = useQueryClient();

  const handleUpdateQuantityOnLeave = () => () => {
    if (!isActive) {
      const updateRequests = orderLines
        .filter((orderItem) => !!orderItem.cartItemId)
        .map((orderItem) => {
          const { cartItemId, quantity } = orderItem;
          return CartApi.updateCartItemQuantity(shopId, cartId, cartItemId!, {
            qty: quantity,
          });
        });
      Promise.allSettled(updateRequests)
        .then(async () => {
          await queryClient.invalidateQueries({ queryKey: queries.cart.detail._def });
          await queryClient.invalidateQueries({ queryKey: queries.cart.cartId._def });
        }).catch(() => {
          toast.error('장바구니 수량 변경 중 오류가 발생했습니다.');
        });
    }
  };

  // 페이지에서 벗어날 때 장바구니 수량 변경
  useEffect(handleUpdateQuantityOnLeave, [isActive, orderLines, toast]);
}

export default useCartQuantity;
